import React, { memo } from "react";
import { Link } from "react-router-dom";

const ItemMenu = memo(({ label, Icon, iconeIm, link, onNavigate }) => {
  const iconeItem = iconeIm ? (
    <img src={iconeIm} alt="" />
  ) : Icon ? (
    <Icon />
  ) : null;

  return (
    <Link
      to={link ?? "/"}
      className="small-box-footer link-menu"
      onClick={onNavigate}
    >
      <div className="container-item-menu">
        <div className={`item-menu-icone${label ? "-label" : ""}`}>
          {iconeItem}
        </div>
        {label ? <div className="item-menu-label">{label}</div> : null}
      </div>
    </Link>
  );
});

ItemMenu.displayName = "ItemMenu";

export default ItemMenu;
